// Packages CTA section scaffold (call-to-action for packages).
import { MessageCircle } from "lucide-react";
import Button from "../../ui/Button";

export default function PackagesCTA({ title, text, buttonText }) {
  return (
    <section className="cta" data-aos="fade-up">
      <div className="cta-icon" aria-hidden="true">
        <MessageCircle />
      </div>
      <h3>{title}</h3>
      <p>{text}</p>
      <Button to="/contact" variant="primary" className="btn-primary">
        {buttonText}
      </Button>
    </section>
  );
}

